// Enums for SDK Errors
export var SDKError;
(function (SDKError) {
    SDKError[SDKError["ErrorNone"] = 0] = "ErrorNone";
    SDKError[SDKError["ErrorNoTransactionName"] = 1] = "ErrorNoTransactionName";
    SDKError[SDKError["ErrorTransactionInProgress"] = 2] = "ErrorTransactionInProgress";
    SDKError[SDKError["ErrorFailedToTakeScreenshot"] = 3] = "ErrorFailedToTakeScreenshot";
    SDKError[SDKError["ErrorInvalidValuesPassed"] = 4] = "ErrorInvalidValuesPassed";
})(SDKError || (SDKError = {}));
//Enums for the pinningMode during the SSL handshake
export var CAMDOSSLPinningMode;
(function (CAMDOSSLPinningMode) {
    CAMDOSSLPinningMode[CAMDOSSLPinningMode["CAMDOSSLPinningModeNone"] = 0] = "CAMDOSSLPinningModeNone";
    CAMDOSSLPinningMode[CAMDOSSLPinningMode["CAMDOSSLPinningModePublicKey"] = 1] = "CAMDOSSLPinningModePublicKey";
    CAMDOSSLPinningMode[CAMDOSSLPinningMode["CAMDOSSLPinningModeCertificate"] = 2] = "CAMDOSSLPinningModeCertificate";
    CAMDOSSLPinningMode[CAMDOSSLPinningMode["CAMDOSSLPinningModeFingerPrintSHA1Signature"] = 3] = "CAMDOSSLPinningModeFingerPrintSHA1Signature";
    CAMDOSSLPinningMode[CAMDOSSLPinningMode["CAMDOSSLPinningModePublicKeyHash"] = 4] = "CAMDOSSLPinningModePublicKeyHash";
})(CAMDOSSLPinningMode || (CAMDOSSLPinningMode = {}));
export var CAMDOSDKImageQualityType;
(function (CAMDOSDKImageQualityType) {
    CAMDOSDKImageQualityType["CAMAA_SCREENSHOT_QUALITY_HIGH"] = "CAMAA_SCREENSHOT_QUALITY_HIGH";
    CAMDOSDKImageQualityType["CAMAA_SCREENSHOT_QUALITY_MEDIUM"] = "CAMAA_SCREENSHOT_QUALITY_MEDIUM";
    CAMDOSDKImageQualityType["CAMAA_SCREENSHOT_QUALITY_LOW"] = "CAMAA_SCREENSHOT_QUALITY_LOW";
    CAMDOSDKImageQualityType["CAMAA_SCREENSHOT_QUALITY_DEFAULT"] = "CAMAA_SCREENSHOT_QUALITY_DEFAULT";
})(CAMDOSDKImageQualityType || (CAMDOSDKImageQualityType = {}));
export var CAMDOUIEventType;
(function (CAMDOUIEventType) {
    CAMDOUIEventType["CAMAA_EVENT_BUTTON_PRESSED"] = "button_pressed";
    CAMDOUIEventType["CAMAA_AI_START"] = "ai_start";
    CAMDOUIEventType["CAMAA_AI_END"] = "ai_end";
    //iOS Specific UI Events
    CAMDOUIEventType["CAMAA_EVENT_DATE_PICKER_VIEW_SELECTED"] = "date_picker_selected";
    CAMDOUIEventType["CAMAA_EVENT_PAGE_CHANGED"] = "page_changed";
    CAMDOUIEventType["CAMAA_EVENT_SEGMENTED_CONTROL_PRESSED"] = "segment_control_pressed";
    CAMDOUIEventType["CAMAA_EVENT_SLIDER_MOVED"] = "slider_moved";
    CAMDOUIEventType["CAMAA_EVENT_STEPPER_PRESSED"] = "stepper_pressed";
    CAMDOUIEventType["CAMAA_EVENT_SWITCH_PRESSED"] = "switch_pressed";
    //Android Specific UI Events
    CAMDOUIEventType["CAMAA_EVENT_RADIO_BUTTON_PRESS"] = "radio_button_pressed";
    CAMDOUIEventType["CAMAA_EVENT_CHECK_BOX_PRESS"] = "check_box_pressed";
    CAMDOUIEventType["CAMAA_EVENT_SPINNER_ITEM_SELECTED"] = "spinner_item_selected";
    CAMDOUIEventType["CAMAA_EVENT_TOGGLE_PRESS"] = "switch_pressed";
    CAMDOUIEventType["CAMAA_EVENT_UNSUPPORTED"] = "unknow_action";
})(CAMDOUIEventType || (CAMDOUIEventType = {}));
export var CAMAA_NOTIFICATION_TYPE;
(function (CAMAA_NOTIFICATION_TYPE) {
    CAMAA_NOTIFICATION_TYPE["CAMAA_UPLOAD_INITIATED"] = "CAMAA_UPLOAD_INITIATED";
    CAMAA_NOTIFICATION_TYPE["CAMAA_CRASH_OCCURRED"] = "CAMAA_CRASH_OCCURRED";
})(CAMAA_NOTIFICATION_TYPE || (CAMAA_NOTIFICATION_TYPE = {}));
//# sourceMappingURL=definitions.js.map